import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config/api";
import "./Notification.css";

const AnnouncementList = ({ limit }) => {
  const [announcements, setAnnouncements] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/get_announcements.php`
        );

        if (res.data.success) {
          let data = res.data.data || [];
          if (limit) data = data.slice(0, limit);
          setAnnouncements(data);
        }
      } catch (err) {
        console.error("Error fetching announcements:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [limit]);

  const toggleReadMore = (id) => {
    setExpandedId((prev) =>
      prev === String(id) ? null : String(id)
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr.replace(" ", "T"));
    if (isNaN(date)) return dateStr;

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  if (!announcements.length) {
    return (
      <div className="text-center py-4">
        No announcements available.
      </div>
    );
  }

  return (
    <>
      {announcements.map((item) => {
        const isExpanded =
          expandedId === String(item.id);

        return (
          <div key={item.id} className="announcement-card">

            {Number(item.is_new) === 1 && (
              <span className="badge-new">NEW</span>
            )}

            <div className="announcement-row">

              <div className="announcement-content">

                <div className="title-date">
                  <span className="announcement-title">
                    {item.title}
                  </span>

                  <span className="announcement-date">
                    Post Date : {formatDate(item.created_at)}
                  </span>
                </div>

                <div className="description-row">
                  <p
                    className={`description-text ${
                      isExpanded
                        ? "expanded"
                        : "collapsed"
                    }`}
                  >
                    {item.description}
                  </p>

                  {item.description.length > 50 && (
                    <span
                      className="read-more-inline"
                      onClick={() =>
                        toggleReadMore(item.id)
                      }
                    >
                      {isExpanded
                        ? " Show Less"
                        : " ... Read More"}
                    </span>
                  )}
                </div>

              </div>

              {item.download_link && (
                <div className="download-section">
                  <a
                    href={item.download_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="download-btn"
                  >
                    <i className="fa-solid fa-download me-1"></i>
                    Download
                  </a>
                </div>
              )}

            </div>
          </div>
        );
      })}
    </>
  );
};

export default AnnouncementList;